import { useFleetNavItems } from './useFleetNavItems';
import type { NavItem } from 'src/common/NavBar/TopLevelNavItemContext';
import { TabNavigation } from 'src/common/TabNavigation';

const fleetTabs: NavItem[] = [
  { name: 'Vehicles', href: '/fleet' },
  { name: 'Inspections', href: '/fleet/inspections' },
];

export function FleetNav() {
  const fleetTabNavItems = useFleetNavItems(fleetTabs);

  return <TabNavigation tabs={fleetTabNavItems} />;
}
